module.exports = __webpack_public_path__ + "static/img/uniteLogo.33647d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageTwo/uniteLogo.png
// module id = QIQR
// module chunks = 0